import { CommonModule } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { merge, Subscription, tap } from 'rxjs';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';

@Component({
  standalone: true,
  selector: 'pm-form-field-error',
  imports: [CommonModule],
  templateUrl: './pm-form-field-error.component.html',
  styleUrl: './pm-form-field-error.component.scss',
})
export class PmFormFieldErrorComponent
  extends FormFieldComponent
  implements OnInit, OnDestroy
{
  errorMessage: WritableSignal<string | null> = signal('');

  private valueChangesSub = new Subscription();

  ngOnInit() {
    this.setErrorMessage();
    const sub = merge(this.ctrl.valueChanges, this.ctrl.statusChanges)
      .pipe(
        tap(() => {
          this.setErrorMessage();
        }),
      )
      .subscribe();
    this.valueChangesSub.add(sub);
  }

  private setErrorMessage() {
    if (this.ctrl.hasError('required')) {
      this.errorMessage.set($localize`To pole jest wymagane`);
    } else if (this.ctrl.hasError('email')) {
      this.errorMessage.set($localize`Niewłaściwy adres email`);
    } else if (this.ctrl.hasError('min')) {
      this.errorMessage.set(
        $localize`Minimalna wartość: ${this.formField.min}`,
      );
    } else if (this.ctrl.hasError('max')) {
      this.errorMessage.set(
        $localize`Maksymalna wartość: ${this.formField.max}`,
      );
    } else if (this.ctrl.hasError('maxLength')) {
      this.errorMessage.set(
        $localize`Maksymalna długość: ${this.formField.maxLength}`,
      );
    } else if (this.ctrl.hasError('minLength')) {
      this.errorMessage.set(
        $localize`Minimalna długość: ${this.formField.minLength}`,
      );
    } else if (this.ctrl.hasError('phoneNumber')) {
      this.errorMessage.set($localize`Niewłaściwy numer telefonu`);
    } else if (this.ctrl?.hasError('startBeforeEnd')) {
      this.errorMessage.set(
        $localize`Czas początkowy musi być mniejszy niż czas końcowy`,
      );
    } else if (this.ctrl?.hasError('availabilitiesOverlap')) {
      this.errorMessage.set($localize`Niektóre z czasów się pokrywają`);
    } else if (this.ctrl?.hasError('availabilityOverlap')) {
      this.errorMessage.set($localize`Te czasy nachodzą na siebie`);
    } else if (this.ctrl?.hasError('verificationFailed')) {
      this.errorMessage.set($localize`Błąd podczas weryfikacji`);
    } else if (this.ctrl?.hasError('tooManyRequests')) {
      this.errorMessage.set(
        $localize`Zbyt wiele prób, spróbuj ponownie za chwilę.`,
      );
    } else if (this.ctrl?.hasError('codeVerificationFailed')) {
      this.errorMessage.set($localize`Wpisany kod jest błędny`);
    } else if (this.ctrl?.hasError('invalidPesel')) {
      this.errorMessage.set($localize`Wpisany pesel jest błędny`);
    } else if (this.ctrl?.hasError('valuesNotSame')) {
      this.errorMessage.set($localize`Wartości nie są takie same`);
    } else if (this.ctrl?.hasError('underageForMe')) {
      this.errorMessage.set($localize`Wizytę należy umówić dla podopiecznego`);
    } else {
      this.errorMessage.set(null);
    }
  }

  ngOnDestroy(): void {
    this.valueChangesSub.unsubscribe();
  }
}
